// Data-driven configuration for the multi-step prequalification form.
// Keeping this separate keeps PrequalForm's cyclomatic complexity low
// and makes it easy to add / reorder steps.

export const PRESUPUESTOS = [
  { v: "<3k", label: "Menos de $3,000 / mes" },
  { v: "3-8k", label: "$3,000 — $8,000 / mes" },
  { v: "8-20k", label: "$8,000 — $20,000 / mes" },
  { v: ">20k", label: "Más de $20,000 / mes" },
];

export const HORIZONTES = [
  { v: "corto", label: "Corto plazo (1–3 años)" },
  { v: "medio", label: "Mediano plazo (3–7 años)" },
  { v: "largo", label: "Largo plazo (7+ años)" },
];

export const DEPENDIENTES = [
  { v: "0" },
  { v: "1" },
  { v: "2" },
  { v: "3" },
  { v: "4+" },
];

// Each step describes: its label for the progress bar, the field it edits,
// and a `isValid(data)` predicate. The rendering itself lives in step
// components colocated in PrequalForm.jsx.
export const PREQUAL_STEPS = [
  {
    id: "proteccion",
    label: "Protección",
    isValid: (d) => !!d.proteccion,
  },
  {
    id: "edad",
    label: "Edad",
    isValid: (d) => !!d.edad && Number(d.edad) > 0,
  },
  {
    id: "estado",
    label: "Ubicación",
    isValid: (d) => !!d.estado,
  },
  {
    id: "presupuesto",
    label: "Presupuesto",
    isValid: (d) => !!d.presupuesto,
  },
  {
    id: "horizonte",
    label: "Horizonte",
    isValid: (d) => !!d.horizonte,
  },
  {
    id: "dependientes",
    label: "Dependientes",
    isValid: (d) => d.dependientes !== "",
  },
  {
    id: "contacto",
    label: "Contacto",
    isValid: (d) => !!d.nombre && !!d.email,
  },
];

export const INITIAL_DATA = {
  proteccion: "",
  edad: "",
  estado: "",
  presupuesto: "",
  horizonte: "",
  dependientes: "",
  nombre: "",
  email: "",
  telefono: "",
  mensaje: "",
};
